/**
 * Sanitize schema for Markdown that allows Cara report section navigation.
 *
 * Extends rehype-sanitize defaultSchema to permit:
 * - Classes: cara-report-nav, cara-report-nav-step, cara-report-nav-connector, cara-report-nav-label
 * - Attributes: data-current, data-step
 *
 * Any preset can use the same HTML structure; only section labels and data-current vary per preset.
 */
import { defaultSchema } from 'rehype-sanitize';

const caraReportNavClassRegex = /^cara-report-nav(-step|-connector|-label|-circle)?$/;

const caraReportNavAttrs = [
  'dataCurrent',
  'dataStep',
  ['className', caraReportNavClassRegex]
] as const;

export const markdownSanitizeSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    div: [...(defaultSchema.attributes?.div ?? []), ...caraReportNavAttrs],
    span: [...(defaultSchema.attributes?.span ?? []), ['className', caraReportNavClassRegex]]
  }
};
